@if (!loading()) {
  <div class="badging-settings-container">
    <div class="events-container">
      <div class="events-wrapper">
        <div class="event">
          <p>Welcome page questions</p>
          <div class="questions-table-wrap">
            @if (isOverviewing()) {
              <app-overview [overview]="overview" [visualIndicator]="visualIndicatorProperty" />
            }
            <mat-tab-group
              [(selectedIndex)]="selectedTab"
              mat-stretch-tabs="false"
              mat-align-tabs="start"
              [hidden]="isOverviewing()"
            >
              <mat-tab label="Questions">
                <div class="tab-container">
                  <app-questions
                    [roomQuestions]="roomBadgeQuestions"
                    (standardQuestions)="setStandardQuestions($event)"
                  />
                </div>
              </mat-tab>
              <mat-tab label="Custom Questions">
                <div class="tab-container">
                  <app-custom [roomQuestions]="roomBadgeQuestions" (customQuestion)="setCustomQuestion($event)" />
                </div>
              </mat-tab>
              <mat-tab label="Visual Indicators">
                <div class="tab-container">
                  <app-visual-indicator
                    [customQuestion]="customQuestion"
                    [roomIndicator]="roomVisualIndicator"
                    (visualIndicator)="visualIndicator = $event"
                    (navigate)="selectedTab = 1"
                  />
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
        <div class="event">
          <p>Smart badge preview</p>
          <div class="event-badge-preview">
            <app-badging-info
              [customStyle]="true"
              [isPreviewCard]="true"
              [user]="_user()"
              [previewBadgeInfo]="{
                userName: formatUserName(userInfo()?.firstName, userInfo()?.lastName),
                companyName: userInfo()?.companyName,
                userTitle: userInfo()?.title,
                aboutMe: userInfo()?.aboutMe,
              }"
            />
          </div>
        </div>
      </div>
      <div class="events-footer">
        @if (isOverviewing()) {
          <app-home-button
            data-testid="create-badging-back-button"
            variant="text"
            color="secondary"
            [flat]="true"
            (click)="isOverviewing.set(false)"
          >
            Back</app-home-button
          >
        }
        <app-home-button data-testid="create-badging-continue-button" (click)="continue()">
          @if (isSaving()) {
            <mat-spinner [diameter]="28"></mat-spinner>
          } @else {
            {{ isOverviewing() ? 'Save Changes' : 'Continue' }}
          }
        </app-home-button>
      </div>
    </div>
  </div>
} @else {
  <div class="loader-container">
    <app-loading />
  </div>
}
